export default __webpack_public_path__ + "static/media/emersonope.9fae819b.jpg";